import React, { useState } from "react";
import { Button, Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const AdmissionCountries = ({ errors, setFormData, admissioncountries }) => {
  const initialEdu = {
    admcntr_id: 0,
    admcntr_country: "",
    admcntr_school: "",
    admcntr_year: "",
    admcntr_grade: "",
    admcntr_instruction: "",
    admcntr_referral: "",
    admcntr_ref_title: "",
    admcntr_email: "",
    admcntr_phone: "",
  };

  const requiredFields = ["admcntr_country", "admcntr_school", "admcntr_year"];

  const [newEdu, setNewEdu] = useState(initialEdu);
  const [newErrors, setNewErrors] = useState({});

  const handleNewEduChange = (e) => {
    const { name, value } = e.target;
    setNewEdu((prev) => ({ ...prev, [name]: value }));
  };

  const addEducation = () => {
    let errorObj = {};

    requiredFields.forEach((field) => {
      if (!newEdu[field].trim()) {
        errorObj[field] = "This field is required";
      }
    });

    setNewErrors(errorObj);

    if (Object.keys(errorObj).length > 0) return;

    // ADD to list
    setFormData((prevData) => ({
      ...prevData,
      admissioncountries: [...prevData.admissioncountries, newEdu],
    }));

    setNewEdu(initialEdu);
    setNewErrors({});
  };

  const handleExistingChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updated = [...prevData.admissioncountries];
      updated[index] = {
        ...updated[index],
        [name]: value,
      };
      return { ...prevData, admissioncountries: updated };
    });
  };

  const removeEducation = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      admissioncountries: prevData.admissioncountries.filter(
        (_, i) => i !== index
      ),
    }));
  };

  return (
    <div>
      {/* ADD NEW SCHOOL ROW */}
      <Row className="align-items-end gy-3">
        <Col xs={12} md={3}>
          <Form.Group>
            <FormattedMessage id="admcntr_country">
              {(placeholder) => (
                <>
                  <Form.Control
                    value={newEdu.admcntr_country}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_country"
                    onChange={handleNewEduChange}
                    isInvalid={!!newErrors.admcntr_country}
                  />
                  <Form.Control.Feedback type="invalid">
                    {newErrors.admcntr_country}
                  </Form.Control.Feedback>
                </>
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col xs={12} md={3}>
          <Form.Group>
            <FormattedMessage id="admcntr_school">
              {(placeholder) => (
                <>
                  <Form.Control
                    value={newEdu.admcntr_school}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_school"
                    onChange={handleNewEduChange}
                    isInvalid={!!newErrors.admcntr_school}
                  />
                  <Form.Control.Feedback type="invalid">
                    {newErrors.admcntr_school}
                  </Form.Control.Feedback>
                </>
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col xs={12} md={2} xxl={1}>
          <Form.Group>
            <FormattedMessage id="admcntr_year">
              {(placeholder) => (
                <>
                  <Form.Control
                    value={newEdu.admcntr_year}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_year"
                    onChange={handleNewEduChange}
                    isInvalid={!!newErrors.admcntr_year}
                  />
                  <Form.Control.Feedback type="invalid">
                    {newErrors.admcntr_year}
                  </Form.Control.Feedback>
                </>
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col xs={12} md={2}>
          <Form.Group>
            <FormattedMessage id="admcntr_grade">
              {(placeholder) => (
                <Form.Control
                  value={newEdu.admcntr_grade}
                  placeholder={placeholder}
                  type="text"
                  name="admcntr_grade"
                  onChange={handleNewEduChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col xs={12} md={3} xxl={3}>
          <Form.Group>
            <FormattedMessage id="admcntr_instruction">
              {(placeholder) => (
                <Form.Control
                  value={newEdu.admcntr_instruction}
                  placeholder={placeholder}
                  type="text"
                  name="admcntr_instruction"
                  onChange={handleNewEduChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col xs={12} md={3}>
          <Form.Group>
            <FormattedMessage id="admcntr_referral">
              {(placeholder) => (
                <Form.Control
                  value={newEdu.admcntr_referral}
                  placeholder={placeholder}
                  type="text"
                  name="admcntr_referral"
                  onChange={handleNewEduChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col xs={12} md={3}>
          <Form.Group>
            <FormattedMessage id="admcntr_ref_title">
              {(placeholder) => (
                <Form.Control
                  value={newEdu.admcntr_ref_title}
                  placeholder={placeholder}
                  type="text"
                  name="admcntr_ref_title"
                  onChange={handleNewEduChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col xs={12} md={3}>
          <Form.Group>
            <FormattedMessage id="admcntr_email">
              {(placeholder) => (
                <Form.Control
                  value={newEdu.admcntr_email}
                  placeholder={placeholder}
                  type="email"
                  name="admcntr_email"
                  onChange={handleNewEduChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col xs={12} md={3}>
          <Form.Group>
            <FormattedMessage id="admcntr_phone">
              {(placeholder) => (
                <Form.Control
                  value={newEdu.admcntr_phone}
                  placeholder={placeholder}
                  type="text"
                  name="admcntr_phone"
                  onChange={handleNewEduChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col xs={12} md={2}>
          <Button variant="primary" onClick={addEducation}>
            + Add School
          </Button>
        </Col>
      </Row>

      <hr />

      {/* EXISTING SCHOOLS */}
      {admissioncountries?.map((edu, index) => (
        <Row key={index} className="align-items-end gy-3 mt-3">
          <Col xs={12} md={3}>
            <Form.Group>
              <FormattedMessage id="admcntr_country">
                {(placeholder) => (
                  <Form.Control
                    value={edu.admcntr_country}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_country"
                    onChange={(e) => handleExistingChange(e, index)}
                    isInvalid={!!errors?.admcntr_country}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>
          <Col xs={12} md={3}>
            <Form.Group>
              <FormattedMessage id="admcntr_school">
                {(placeholder) => (
                  <Form.Control
                    value={edu.admcntr_school}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_school"
                    onChange={(e) => handleExistingChange(e, index)}
                    isInvalid={!!errors?.admcntr_school}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>
          <Col xs={12} md={2} xxl={1}>
            <Form.Group>
              <FormattedMessage id="admcntr_year">
                {(placeholder) => (
                  <Form.Control
                    value={edu.admcntr_year}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_year"
                    onChange={(e) => handleExistingChange(e, index)}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>

          <Col xs={12} md={2}>
            <Form.Group>
              <FormattedMessage id="admcntr_grade">
                {(placeholder) => (
                  <Form.Control
                    value={edu.admcntr_grade}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_grade"
                    onChange={(e) => handleExistingChange(e, index)}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>

          <Col xs={12} md={3}>
            <Form.Group>
              <FormattedMessage id="admcntr_instruction">
                {(placeholder) => (
                  <Form.Control
                    value={edu.admcntr_instruction}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_instruction"
                    onChange={(e) => handleExistingChange(e, index)}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>

          <Col xs={12} md={3}>
            <Form.Group>
              <FormattedMessage id="admcntr_referral">
                {(placeholder) => (
                  <Form.Control
                    value={edu.admcntr_referral}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_referral"
                    onChange={(e) => handleExistingChange(e, index)}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>

          <Col xs={12} md={3}>
            <Form.Group>
              <FormattedMessage id="admcntr_ref_title">
                {(placeholder) => (
                  <Form.Control
                    value={edu.admcntr_ref_title}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_ref_title"
                    onChange={(e) => handleExistingChange(e, index)}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>

          <Col xs={12} md={3}>
            <Form.Group>
              <FormattedMessage id="admcntr_email">
                {(placeholder) => (
                  <Form.Control
                    value={edu.admcntr_email}
                    placeholder={placeholder}
                    type="email"
                    name="admcntr_email"
                    onChange={(e) => handleExistingChange(e, index)}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>

          <Col xs={12} md={3} xxl={2}>
            <Form.Group>
              <FormattedMessage id="admcntr_phone">
                {(placeholder) => (
                  <Form.Control
                    value={edu.admcntr_phone}
                    placeholder={placeholder}
                    type="text"
                    name="admcntr_phone"
                    onChange={(e) => handleExistingChange(e, index)}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>

          <Col xs={12} md={1}>
            <Button variant="danger" onClick={() => removeEducation(index)}>
              -
            </Button>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default AdmissionCountries;
